import React, {useCallback, useEffect, useState} from 'react';
import Wrapper from "../components/Wrapper";
import Api from "../Api";
import Loader from "../components/Loader";
import Paper from "@mui/material/Paper";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Select from "react-select";
import {TableFooter} from "@mui/material";
import {toast} from "react-toastify";
import {useDispatch, useSelector} from "react-redux";
import {userCrmRequest} from "../store/actions/users";
const {REACT_APP_SERVER} = process.env;

const customStyles = {
    menu: (provided) => ({
        ...provided,
        position: 'absolute',
        zIndex: 9999,
        maxHeight: 300,
    }),
    menuPortal: (base) => ({...base, zIndex: 9999}), // Ensures portal menu is above modal
};
let color = REACT_APP_SERVER === 'ATS' ? '#0973b9' : '#7ebc0a'

let newArr = []
function Uon(props) {
    const [loading, setLoading] = useState(false)
    const [uon,setUon] = useState([])
    const [sipNum, setSip] = useState([]);
    const dispatch = useDispatch()
    const userData = useSelector((state) => state.users.crmData)
    useEffect(() => {
        (async () => {
            await dispatch(userCrmRequest())
        })()
    }, [])
    const handleSipSelect = useCallback((sip, id) => {
        newArr.map(u => {
            if (u.userid === id) {
                u.sip = sip
            }
        })
        setUon(prev =>
            prev.map(u => {
                if (u.u_id === id) {
                    return {...u, sip: sip};
                }
                return u;
            })
        );
    }, [])
    useEffect(() => {
        (async () => {
            setLoading(true)
            const {data} = await Api.uonUsers();
            newArr = data.data.users.map(u => ({userid: u.u_id, sip: u.sip || ''}))
            setUon(data.data.users)
            const new_data = await Api.getAllowed()
            setSip(new_data.data.inputNumber?.sip)
            setLoading(false)
        })()
    }, [])

    const handleSave = useCallback(async (item) =>{
        try {
            let f = newArr.find((s) => s.userid === item.u_id)
            if (item.sip) {
                if (item.crm_id) {
                    await Api.uonCrmEdit({...f, id: item.crm_id})
                    const {data} = await Api.uonUsers();
                    setUon(data.data.users)
                    newArr = data.data.users.map(u => ({userid: u.u_id, sip: u.sip || ''}))
                    toast.success("Successfully edited")
                } else {
                    await Api.uonCrmCreate({...f})
                    const {data} = await Api.uonUsers();
                    setUon(data.data.users)
                    newArr = data.data.users.map(u => ({userid: u.u_id, sip: u.sip || ''}))
                    toast.success("Successfully created")
                }
            } else if (item.crm_id) {
                await Api.uonCrmDelete(item.crm_id)
                const {data} = await Api.uonUsers();
                setUon(data.data.users)
                newArr = data.data.users.map(u => ({userid: u.u_id, sip: u.sip || ''}))
                toast.success("Successfully created")
            }
        } catch (e) {
            console.log(e)
        }
    },[])
    return (
        <Wrapper>
            {loading ? <div className="loaderContainer"><Loader/></div> :
                <div className="tableParent" id="tableParent">
                    <Paper sx={{minWidth: 'fit-content', fontSize: 10}}>
                        <TableContainer
                        >
                            <Table stickyHeader aria-label="sticky table">
                                <TableHead>
                                    <TableRow className="sip_header">
                                        <TableCell sx={{fontSize: 20,}} align="left" colSpan={9}>
                                            Users of UonCRM - {userData?.uon?.domain} {uon.u_company?' - '+uon.u_company:''}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow className="sip_num">
                                        <TableCell
                                            align='center'
                                        />
                                        <TableCell align='center'>
                                            ID
                                        </TableCell>
                                        <TableCell align='center'>
                                            Full name
                                        </TableCell>
                                        <TableCell align='center'>
                                            Email
                                        </TableCell>
                                        <TableCell
                                            align='center'
                                        >
                                            Type
                                        </TableCell>
                                        <TableCell
                                            align='center'
                                        >
                                            Register date
                                        </TableCell>

                                        <TableCell
                                            align='center'
                                        >
                                            Selected SIP
                                        </TableCell>

                                        <TableCell
                                            align='center'
                                        >
                                            Action
                                        </TableCell>

                                    </TableRow>
                                </TableHead>
                                <TableBody id="dataBody">
                                    {uon.length ? uon.map((s, _) => (
                                        <TableRow key={_} hover style={{cursor: 'pointer'}} role="checkbox"
                                                  tabIndex={-1}>
                                            <TableCell align="center" onClick={() => null}>
                                                {s?.active?
                                                    <CheckCircleIcon style={{color: color}}/> : null}
                                            </TableCell>
                                            <TableCell align="center">
                                                {s?.u_id}
                                            </TableCell>
                                            <TableCell align="center" onClick={() => null}>
                                                {s.u_name} {s.u_surname}
                                            </TableCell>
                                            <TableCell align="center" onClick={() => null}>
                                                {s.u_email}
                                            </TableCell>
                                            <TableCell align="center" onClick={() => null}>
                                                {s.role_id === 1?'Admin':''}
                                            </TableCell>
                                            <TableCell align="center" onClick={() => null}>
                                                {new Date(s.u_date_update).toDateString()}
                                            </TableCell>
                                            <TableCell align="center" style={{width: 160}}>
                                                <Select
                                                    styles={customStyles}
                                                    menuPlacement="auto"
                                                    menuPosition="fixed"
                                                    onChange={(ev) => handleSipSelect(ev.value, s.u_id,)}
                                                    menuPortalTarget={document.body}
                                                    className="basic-single"
                                                    classNamePrefix="select"
                                                    isSearchable={true}
                                                    value={{label: s.sip, value: s.sip}}
                                                    name="color"
                                                    options={[{number: '', label: 'Select value'}, ...sipNum.map(k => (
                                                        {value: +k.number, label: `${k.number} ${k.context || ''}`}
                                                    ))]}
                                                />
                                            </TableCell>

                                            <TableCell >
                                                <button onClick={() => handleSave(s)} className="addBtn">
                                                    Save
                                                </button>
                                            </TableCell>
                                        </TableRow>

                                    )) : <TableRow hover role="checkbox" tabIndex={-1}>


                                        <TableCell align="center" colSpan={window.innerWidth < 400 ? 6 : 10}>
                                            no data

                                        </TableCell>


                                    </TableRow>
                                    }
                                    {/*    );*/}
                                    {/*})}*/}
                                </TableBody>
                                <TableFooter>
                                    <TableRow>
                                        <TableCell align="center" colSpan={window.innerWidth < 400 ? 6 : 10}>
                                            <div style={{margin: 10}} className="crm_save_btn"/>
                                        </TableCell>
                                    </TableRow>
                                </TableFooter>
                            </Table>
                        </TableContainer>
                    </Paper>
                </div>}
        </Wrapper>

    );
}

export default Uon;
